var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotificationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.16699 4.58333C9.16699 3.57081 9.9878 2.75 11.0003 2.75C12.0128 2.75 12.8337 3.57081 12.8337 4.58333C14.9788 5.59767 16.3891 7.71306 16.5003 10.0833V12.8333C16.6402 13.9891 17.3206 15.0097 18.3337 15.5833H3.66699C4.68001 15.0097 5.36043 13.9891 5.50033 12.8333V10.0833C5.61158 7.71306 7.02184 5.59767 9.16699 4.58333",
    stroke: "#4B465C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.16699 4.58333C9.16699 3.57081 9.9878 2.75 11.0003 2.75C12.0128 2.75 12.8337 3.57081 12.8337 4.58333C14.9788 5.59767 16.3891 7.71306 16.5003 10.0833V12.8333C16.6402 13.9891 17.3206 15.0097 18.3337 15.5833H3.66699C4.68001 15.0097 5.36043 13.9891 5.50033 12.8333V10.0833C5.61158 7.71306 7.02184 5.59767 9.16699 4.58333",
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 15.5833V16.4999C8.25 18.0187 9.48122 19.2499 11 19.2499C12.5188 19.2499 13.75 18.0187 13.75 16.4999V15.5833",
    stroke: "#4B465C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 15.5833V16.4999C8.25 18.0187 9.48122 19.2499 11 19.2499C12.5188 19.2499 13.75 18.0187 13.75 16.4999V15.5833",
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIcon);
export default __webpack_public_path__ + "static/media/notificationIcon.9c4e81aa214f0dce2ae3b0f508f72b89.svg";
export { ForwardRef as ReactComponent };